// src/contexts/PyodideContext.jsx
import React, { createContext, useEffect, useState } from 'react';

export const PyodideContext = createContext();

export const PyodideProvider = ({ children }) => {
  const [pyodide, setPyodide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const initPyodide = async () => {
      try {
        const py = await window.loadPyodide();
        if (cancelled) return;
        setPyodide(py);
        setLoading(false);
      } catch (err) {
        console.error('❌ Failed to initialize Pyodide.', err);
        if (cancelled) return;
        setError(err);
        setLoading(false);
      }
    };

    if (!window.loadPyodide) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/pyodide/v0.25.1/full/pyodide.js';
      script.onload = () => {
        console.log('✅ Pyodide script loaded.');
        initPyodide();
      };
      script.onerror = () => {
        console.error('❌ Failed to load Pyodide script.');
        if (cancelled) return;
        setError(new Error('Failed to load the Pyodide script from the CDN.'));
        setLoading(false);
      };
      document.body.appendChild(script);
    } else {
      initPyodide();
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <PyodideContext.Provider value={{ pyodide, loading, error }}>
      {children}
    </PyodideContext.Provider>
  );
};
